import { createFromIconfontCN } from '@ant-design/icons';
import configs from '@/configs';

const IconfontCN = createFromIconfontCN({
  scriptUrl: configs('app.iconScriptUrl'), // 在 iconfont.cn 上生成
});

export default IconfontCN;
